import React from 'react';
import { BRAND, localePath } from '../../../config/region';

/*
 * "academy-silver-thorn" in every language it has been translated into.
 *
 * Shared fields (slug, dates) sit at the top level; each language supplies only what differs.
 * Russian is the authored original. A language that is missing here falls back to English, or to
 * Russian in the russia build — see blogPosts/index.js.
 */
const post = {
  slug: 'academy-silver-thorn',
  datePublished: '2026-09-06',
  dateModified: '2026-09-06',

  russian: {
    title: '🥀 Смерть на второй день или романтика под алым закатом? «Академия Серебряного Шипа: Перо и Кровь»',
    description: 'Вы очнулись в теле злодейки, и у вас есть несколько дней, чтобы переписать чужой сюжет — или отправиться на эшафот.',
    seoTitle: `Академия Серебряного Шипа: Перо и Кровь — интерактивная новелла про злодейку — ${BRAND}`,
    seoDescription: 'Троп «злодейки» в интерактивной ИИ-новелле: живые персонажи, выбор с настоящей ценой и эстетика корейских вебтунов. Играйте в «Академию Серебряного Шипа: Перо и Кровь».',
    content: (
      <>
        <h2>Феномен «Злодейки»: почему мы так хотим переписать чужой сюжет?</h2>

        <p>Каждый, кто хоть раз открывал популярные платформы с манхвой или вебтунами, знает это чувство ٩(◕‿◕｡)۶. Вы листаете каталог и снова видите её — эффектную девушку в роскошном платье, которая вдруг осознаёт: она не главная героиня. Она — злодейка. Та самая, чья участь в оригинальной истории расписана по секундам: публичный позор, изгнание или эшафот под ликующие возгласы толпы.</p>

        <p>Троп «villainess» завоевал миллионы сердец по всему миру не просто так. Это идеальный психологический крючок! Он даёт нам то, чего так не хватает в жизни — шанс бросить вызов самой «Судьбе» (или вредному Автору истории) и доказать, что никто не обязан играть навязанную роль.</p>

        <p>Но одно дело — сопереживать героине через экран смартфона, и совсем другое — самому очнуться в её теле (⁄ ⁄•⁄ω⁄•⁄ ⁄).</p>

        <p>Представьте: вы открываете глаза, а в вашей руке — бокал сока. Напротив стоит «святая» любимица академии со слезами на глазах, а вокруг замерли сотни аристократов. В этот момент за кадром раздаётся ироничный голос:</p>

        <p><em>«У вас есть всего несколько дней, чтобы изменить отношение окружающих. Иначе — увы, смерть!»</em></p>

        <p>Именно с этого момента начинается ваше погружение в <a href={localePath('/play/feather-and-blood')}>«Академию Серебряного Шипа: Перо и Кровь»</a> — уникальную интерактивную историю, где границы между вами и миром манхвы стираются навсегда! (✧ω✧)</p>

        <h2>Живые персонажи с душой: когда ИИ становится настоящим собеседником</h2>

        <p>Главная магия игры скрывается в том, как устроен этот мир. Забудьте о старых визуальных новеллах, где вам давали три шаблонные кнопочки с ответами, из которых «правильная» читалась за версту (￣ω￣).</p>

        <p>В «Академии Серебряного Шипа: Перо и Кровь» за каждого персонажа отвечает продвинутый искусственный интеллект! Но не бойтесь сухости или случайных фраз — ИИ здесь строго ограничен проработанным лором, глубоким характером и личной историей каждого героя (^‿^).</p>

        <p>Вы общаетесь не с кодом, а с настоящей личностью:</p>

        <ul>
          <li><strong>Холодный принц</strong> помнит о долге перед короной, но под его ледяной маской скрывается уязвимый человек, уставший от лицемерия 👑.</li>
          <li><strong>Гордый рыцарь</strong> свято верит в кодекс, но заставит вас ахнуть, если вы заденете его сокровенные чувства ⚔️.</li>
          <li><strong>Гениальный маг</strong> смотрит на всё сквозь призму скепсиса, но его любопытство вспыхнет ярче пламени, если вы проявите острый ум 🔮.</li>
          <li><strong>Тихий юноша</strong> в тени библиотеки скрывает больше тайн, чем вся академия вместе взятая 🖤.</li>
        </ul>

        <p>Каждый из них живёт по законам своего характера (´｡• ᵕ •｡) ♡. Если вы попытаетесь соврать — вас раскусят. Если заговорите об их прошлом — они удивятся. Вы можете задавать абсолютно любые вопросы, уходить в сторону от стандартного диалога, шутить, флиртовать или неожиданно раскрывать душу!</p>

        <p>Вы способны построить такие отношения, которые изначально даже не предполагались каноном истории! Начните общаться с тем, кого все считали врагом, и посмотрите, как искренний разговор растапливает самое чёрствое сердце ♡ (˘▽˘)ԅ( ˘⌣˘).</p>

        <h2>Выбор с настоящей ценой: от эшафота до романтического заката</h2>

        <p>В этой истории нет «безопасных» дней. Мир Серебряного Шипа живёт в бешеном темпе, и правила здесь честные, но суровые ٩(｡•́‿•̀｡)۶.</p>

        <p>Вы действительно можете допустить роковую ошибку и зайти в тупик уже на второй день! Проигнорировали странности вокруг? Нагрубили тем, кто мог стать вашим единственным союзником? Будьте готовы к тому, что история оборвётся самым неожиданным образом (x_x)⌒☆.</p>

        <p>Но если вы проявите чуткость, сообразительность и каплю обаяния — тот же самый день заиграет совершенно иными красками!</p>

        <p>Вместо тёмной темницы вы можете отправиться на прогулку по уютным улочкам с красавцем, который ещё вчера смотрел на вас с презрением. Вы будете смеяться, выбирать наряды, делиться секретами и завершите этот вечер на оборонной стене или набережной, наблюдая, как багровый закат окрашивает город в золотые тона (｡・//ε//・｡) ♡.</p>

        <h2>Небольшой гид по вашим решениям (и их забавным последствиям!)</h2>

        <p>Чтобы вы понимали, насколько тонки грани в Академии, взгляните на эту табличку:</p>

        <table>
          <thead>
            <tr>
              <th>Ваше действие в игре</th>
              <th>К чему это приведёт?</th>
              <th>Шанс на выживание и градус эмоций</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Нагрубить горничной с утра</td>
              <td>Получите по шляпе (фигурально) и потеряете единственную улику, которую она заботливо припрятала (—_—)</td>
              <td>📉 Шансы падают к нулю!</td>
            </tr>
            <tr>
              <td>Улыбнуться и ответить с душой</td>
              <td>Получите секретный дневник, чашку горячего чая и верного друга навсегда (o^▽^o)</td>
              <td>📈 +100 к карме и защите!</td>
            </tr>
            <tr>
              <td>Игнорировать подозрительные детали 2 дня подряд</td>
              <td>Договоритесь до того, что канон выплюнет вас на рассвете второго дня (×﹏×)</td>
              <td>💀 Ой… Кажется, это финал!</td>
            </tr>
            <tr>
              <td>Пригласить холодного мага или принца на прогулку</td>
              <td>Искренний удивлённый взгляд, смущённый румянец и вечер под багровым закатом {'(⁄ ⁄>⁄ ▽ ⁄<⁄ ⁄)'}</td>
              <td>💖 Романтика зашкаливает!</td>
            </tr>
            <tr>
              <td>Задать рыцарю вопрос о его личном хобби</td>
              <td>Он забудет про свой суровый вид и полчаса будет вдохновенно рассказывать вам про лошадей (─‿‿─)♡</td>
              <td>🐴 Неожиданная милота!</td>
            </tr>
            <tr>
              <td>Спросить у тихого парня из библиотеки его имя</td>
              <td>Вы станете первым человеком за пять лет, кто вообще его заметил… (°◡°♡)</td>
              <td>🗝️ Открыт тайный сюжетный путь!</td>
            </tr>
          </tbody>
        </table>

        <h2>Визуальный ряд: когда оживает задумка автора</h2>

        <p>Отдельное наслаждение — это то, как «Академия Серебряного Шипа: Перо и Кровь» выглядит (♡°▽°♡).</p>

        <p>Каждая локация здесь создана так, чтобы передать идеальную эстетику корейских вебтунов:</p>

        <ul>
          <li>Мягкий свет заходящего солнца, пробивающийся сквозь высокие витражные окна спальни.</li>
          <li>Таинственные стеллажи величественной библиотеки, где в воздухе парят золотинки пыли.</li>
          <li>Холодный блеск рыцарских доспехов на тренировочном дворе ⚔️.</li>
          <li>И роскошный бальный зал, готовый стать ареной для вашей главной победы!</li>
        </ul>

        <p>Визуальный ряд не просто украшает текст — он передаёт мельчайшие детали атмосферы, которую задумывал Автор. Вы видите каждую эмоцию на лицах персонажей, каждый полутон освещения и каждый вздох, делая погружение на 100% глубоким! ☆:(─‿‿─):☆</p>

        <h2>Хватит быть просто читателем — перепишите эту историю сами!</h2>

        <p>Сколько раз, читая очередную манхву, вы кричали в экран: «Ну почему она поступает так глупо?! Я бы на её месте сделала всё иначе!»?</p>

        <p>Время пришло! ╰(▔∀▔)╯</p>

        <p>В «Академии Серебряного Шипа: Перо и Кровь» больше нет готовых сценариев, заставляющих вас идти по чужим стопам. Здесь есть вы, живые персонажи, готовые услышать каждое ваше слово, и тикающие часы, отсчитывающие время до заката.</p>

        <p>Сможете ли вы разоблачить чужие интриги? Завоюете ли сердце того, кто казался неприступным? Или создадите свой собственный, совершенно непредсказуемый финал?</p>

        <p>Не ждите, пока за вас напишут последнюю главу! 👉 <a href={localePath('/play/feather-and-blood')}>Переходите в игру прямо сейчас</a>, открывайте двери Академии Серебряного Шипа и докажите всему миру, на что способна настоящая Злодейка! ٩(˘▽˘)۶</p>
      </>
    ),
  },

  english: {
    title: '🥀 Dead by day two, or romance under a crimson sunset? "Academy of the Silver Thorn: Quill and Blood"',
    description: 'You wake up in the villainess’s body with a handful of days to rewrite someone else’s plot — or walk to the scaffold.',
    seoTitle: `Academy of the Silver Thorn: Quill and Blood — an interactive villainess novel — ${BRAND}`,
    seoDescription: 'The villainess trope in an interactive AI novel: characters who actually answer, choices with a real price, and Korean webtoon aesthetics. Play "Academy of the Silver Thorn: Quill and Blood".',
    content: (
      <>
        <h2>The villainess phenomenon: why do we want to rewrite someone else’s plot so badly?</h2>

        <p>Anyone who has ever opened a manhwa or webtoon app knows the feeling ٩(◕‿◕｡)۶. You scroll the catalogue and there she is again — a striking young woman in a magnificent gown who suddenly realises she is not the heroine. She is the villainess. The one whose fate the original story has already timed to the minute: public disgrace, exile, or the scaffold to the cheers of the crowd.</p>

        <p>The villainess trope won millions of hearts for a reason. It is a perfect psychological hook, because it offers the thing real life so rarely does — a chance to argue with Fate itself (or with a spiteful Author) and prove that nobody is obliged to play the part they were handed.</p>

        <p>But sympathising with a heroine through a phone screen is one thing. Waking up inside her is quite another (⁄ ⁄•⁄ω⁄•⁄ ⁄).</p>

        <p>Picture it: you open your eyes holding a glass of juice. Opposite you stands the academy’s beloved «saint», eyes brimming with tears, and hundreds of aristocrats have gone very still. And then an amused voice says, from somewhere off-stage:</p>

        <p><em>«You have a few days to change how these people see you. Otherwise — well. Death!»</em></p>

        <p>That is where <a href={localePath('/play/feather-and-blood')}>«Academy of the Silver Thorn: Quill and Blood»</a> begins — an interactive story where the wall between you and the world of the manhwa comes down for good (✧ω✧).</p>

        <h2>Characters with an inner life: when the AI becomes a real conversation partner</h2>

        <p>The magic is in how this world is built. Forget the old visual novels that handed you three template buttons with the «right» one visible from a mile off (￣ω￣).</p>

        <p>In «Academy of the Silver Thorn: Quill and Blood» every character is played by an advanced AI. But do not expect dryness or non-sequiturs — the AI is held tightly inside worked-out lore, a real temperament and a personal history for each of them (^‿^).</p>

        <p>You are not talking to code. You are talking to a person:</p>

        <ul>
          <li>The <strong>cold prince</strong> never forgets what he owes the crown, but behind the ice is someone vulnerable and tired of the hypocrisy 👑.</li>
          <li>The <strong>proud knight</strong> believes in his code absolutely — and will take your breath away if you touch what he actually cares about ⚔️.</li>
          <li>The <strong>brilliant mage</strong> views everything through a sceptic’s lens, but his curiosity catches fire the moment you show a sharp mind 🔮.</li>
          <li>The <strong>quiet young man</strong> in the shadows of the library keeps more secrets than the rest of the academy put together 🖤.</li>
        </ul>

        <p>Each of them lives by the logic of their own character (´｡• ᵕ •｡) ♡. Lie, and you will be seen through. Bring up their past, and they will be surprised you know. You can ask anything at all, wander off the expected dialogue, joke, flirt, or say something unexpectedly honest.</p>

        <p>You can build relationships the canon never intended to allow. Start talking to the one everybody wrote off as the enemy, and watch a genuine conversation thaw the hardest heart in the building ♡ (˘▽˘)ԅ( ˘⌣˘).</p>

        <h2>Choices with a real price: from the scaffold to a romantic sunset</h2>

        <p>There are no «safe» days in this story. The Silver Thorn moves fast, and its rules are fair but unforgiving ٩(｡•́‿•̀｡)۶.</p>

        <p>You really can make a fatal mistake and hit a dead end on day two. Ignored the odd things happening around you? Snapped at the one person who might have become your only ally? Then be ready for the story to end in a way you did not see coming (x_x)⌒☆.</p>

        <p>But show some perception, some quick thinking and a little charm, and that exact same day turns a completely different colour.</p>

        <p>Instead of a dark cell you might find yourself walking the old streets beside someone who looked straight through you yesterday. You will laugh, argue about clothes, trade secrets, and end the evening on the rampart or the embankment while a crimson sunset turns the city gold (｡・//ε//・｡) ♡.</p>

        <h2>A short guide to your decisions (and their entertaining consequences)</h2>

        <p>To show you how fine the margins are at the Academy, take a look at this:</p>

        <table>
          <thead>
            <tr>
              <th>What you do</th>
              <th>What it leads to</th>
              <th>Survival odds and emotional temperature</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Snap at the maid first thing in the morning</td>
              <td>You get told off (figuratively) and lose the one piece of evidence she had carefully hidden for you (—_—)</td>
              <td>📉 Odds heading for zero!</td>
            </tr>
            <tr>
              <td>Smile and answer her like a human being</td>
              <td>You get a secret diary, a cup of hot tea and a loyal friend for life (o^▽^o)</td>
              <td>📈 +100 karma and protection!</td>
            </tr>
            <tr>
              <td>Ignore the suspicious details two days running</td>
              <td>You talk yourself into a corner and the canon spits you out at dawn on day two (×﹏×)</td>
              <td>💀 Oh… that appears to be the ending!</td>
            </tr>
            <tr>
              <td>Invite the cold mage or the prince out for a walk</td>
              <td>A genuinely startled look, an embarrassed flush, and an evening under a crimson sunset {'(⁄ ⁄>⁄ ▽ ⁄<⁄ ⁄)'}</td>
              <td>💖 Romance off the scale!</td>
            </tr>
            <tr>
              <td>Ask the knight about his hobby</td>
              <td>He drops the stern act and spends half an hour telling you about horses, with feeling (─‿‿─)♡</td>
              <td>🐴 Unexpectedly adorable!</td>
            </tr>
            <tr>
              <td>Ask the quiet library boy his name</td>
              <td>You become the first person in five years to notice he exists… (°◡°♡)</td>
              <td>🗝️ Secret story path unlocked!</td>
            </tr>
          </tbody>
        </table>

        <h2>The art: when the author’s idea comes to life</h2>

        <p>A pleasure of its own is simply how «Academy of the Silver Thorn: Quill and Blood» looks (♡°▽°♡).</p>

        <p>Every location is built to land the Korean webtoon aesthetic exactly:</p>

        <ul>
          <li>Soft late-afternoon light coming through the tall stained-glass windows of the bedroom.</li>
          <li>The secretive shelves of the great library, with gold dust hanging in the air.</li>
          <li>The cold shine of armour in the training yard ⚔️.</li>
          <li>And a magnificent ballroom, ready to host your finest hour.</li>
        </ul>

        <p>The art does not merely decorate the text — it carries the small details of the atmosphere the Author had in mind. You see every emotion crossing a face, every half-tone of the light and every caught breath, and the immersion goes all the way down ☆:(─‿‿─):☆</p>

        <h2>Stop being a reader — rewrite this story yourself</h2>

        <p>How many times, reading yet another manhwa, have you shouted at the screen: «Why is she doing something so stupid?! I would have handled that completely differently!»</p>

        <p>Your moment has arrived ╰(▔∀▔)╯</p>

        <p>«Academy of the Silver Thorn: Quill and Blood» has no ready-made script marching you along in someone else’s footsteps. There is you, characters who will hear every word you say, and a clock counting down to sunset.</p>

        <p>Can you expose the schemes running around you? Win over the one who seemed unreachable? Or write your own completely unpredictable ending?</p>

        <p>Do not wait for someone else to write your final chapter. 👉 <a href={localePath('/play/feather-and-blood')}>Open the game now</a>, push open the doors of the Academy of the Silver Thorn, and show everyone what a real villainess can do ٩(˘▽˘)۶</p>
      </>
    ),
  },
};

export default post;
